import { MenuAggregate, SectionAggregate } from "@aitisal/contracts/restaurant/menu";
import { useEffect, useMemo } from "react";
import { useMenuStore } from "../stores/menuStore";
import { useMenuAggregate } from "./useMenuAggregate";
import getCurrentlyAvailableMenus from "../utils/getAvailableMenus";

export interface ActiveMenu {
  menu: MenuAggregate | null;
  sections: SectionAggregate[];
}

export function useActiveMenu(): ActiveMenu {
  const { data: menusData } = useMenuAggregate();
  const { activeMenuId, setActiveMenuId } = useMenuStore();

  const menus = useMemo(
    () => (menusData?.menus ? getCurrentlyAvailableMenus(menusData.menus) : []),
    [menusData?.menus],
  );

  const activeMenu = useMemo(() => {
    if (!menus.length) return null;
    if (activeMenuId) {
      const match = menus.find((m) => m.menuId === activeMenuId);
      if (match) return match;
    }
    return menus[0];
  }, [menus, activeMenuId]);

  useEffect(() => {
    if (activeMenu && activeMenu.menuId !== activeMenuId) {
      setActiveMenuId(activeMenu.menuId);
    }
  }, [activeMenu, activeMenuId, setActiveMenuId]);

  const sections = useMemo(() => {
    if (!activeMenu) return [];
    return [...(activeMenu.sections || [])]
      .filter(Boolean)
      .sort((a: any, b: any) => {
        if (a.type === "FEATURED" && b.type !== "FEATURED") return -1;
        if (a.type !== "FEATURED" && b.type === "FEATURED") return 1;
        return (a.position || 0) - (b.position || 0);
      });
  }, [activeMenu]);

  return { menu: activeMenu, sections };
}